<app-radio-button
  [header]="CONSTS.LABEL"
  [radioModel]="radioButtonValue"
  [firstOptionValue]="Options.PDF"
  [firstOptionName]="CONSTS.OPTION_1"
  [secondOptionValue]="Options.CSV"
  [secondOptionName]="CONSTS.OPTION_2"
  [hasPadding]="false"
  (buttonChange)="sendRadioButtonChange($event)"
>
</app-radio-button>
